import { useEffect } from 'react'
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import RenderRoutes from './router/RenderRoutes'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import { getCurrentUser } from 'redux/modules/auth/actions'
import { useDispatch } from 'react-redux'
import GlobalSnackbarHost from 'SnackbarGlobal'

const App = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCurrentUser())
  }, [])

  return (
    <>
      <Router>
        <Switch>
          <RenderRoutes />
        </Switch>
      </Router>
      <GlobalSnackbarHost />
    </>
  )
}

export default App
